var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0"},[_c('v-col',{attrs:{"cols":"8"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('Configuração de indicadores')))]),_c('span',[_vm._v(" "+_vm._s(_vm.$t( 'Configure cada indicador escolhido e adicione sua análise crítica' ))+" ")])]),_c('v-col',{staticClass:"d-flex justify-end",attrs:{"cols":"4"}},[(_vm.isEditing)?_c('v-btn',{staticClass:"primary-button ma-0",attrs:{"depressed":""},on:{"click":_vm.refreshData}},[_vm._v(" Atualizar dados ")]):_vm._e()],1),_c('v-col',{attrs:{"cols":"12"}},[_c('v-divider')],1),(_vm.selection.filter((x) => x.includes('1.')).length > 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('strong',[_vm._v(_vm._s(_vm.$t('Quantitativos')))])]),_c('v-expansion-panel-content',[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[(_vm.selection.includes('1.1 - Equipamentos por setor'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.1")]),_vm._v(" "+_vm._s(_vm.$t('Equipamentos por setor'))+" ")])]),_c('v-expansion-panel-content',[_c('EquipmentBySectorChart',{attrs:{"filterProp":_vm.isEditing
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.1 - Equipamentos por setor'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.1 - Equipamentos por setor'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.1 - Equipamentos por setor'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.2 - Equipamentos Desativados no Período'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.2")]),_vm._v(" "+_vm._s(_vm.$t('Equipamentos Desativados no Período'))+" ")])]),_c('v-expansion-panel-content',[_c('AlienatedEquip',{attrs:{"filterProp":_vm.isEditing
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.2 - Equipamentos Desativados no Período'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart == '1.2 - Equipamentos Desativados no Período'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.2 - Equipamentos Desativados no Período'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('1.3 - Solicitações por setor'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.3")]),_vm._v(" "+_vm._s(_vm.$t('Solicitações por setor'))+" ")])]),_c('v-expansion-panel-content',[_c('RequestBySector',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.3 - Solicitações por setor'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.3 - Solicitações por setor'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.3 - Solicitações por setor'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.3 - Solicitações por setor'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.4 - Equipamentos Parados x Tipo de Pendencia'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.4")]),_vm._v(" "+_vm._s(_vm.$t('Equipamentos Parados x Tipo de Pendencia'))+" ")])]),_c('v-expansion-panel-content',[_c('StoppedEquipPendingType',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.4 - Equipamentos Parados x Tipo de Pendencia'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.4 - Equipamentos Parados x Tipo de Pendencia'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.4 - Equipamentos Parados x Tipo de Pendencia'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.4 - Equipamentos Parados x Tipo de Pendencia'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes('1.5 - Top 5 equipamentos com mais falhas')
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.5")]),_vm._v(" "+_vm._s(_vm.$t('Top 5 equipamentos com mais falhas'))+" ")])]),_c('v-expansion-panel-content',[_c('TopFiveEquipFailures',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart == '1.5 - Top 5 equipamentos com mais falhas'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.5 - Top 5 equipamentos com mais falhas'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart == '1.5 - Top 5 equipamentos com mais falhas'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.5 - Top 5 equipamentos com mais falhas'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('1.6 - Prevalência solução defeito'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.6")]),_vm._v(" "+_vm._s(_vm.$t('Prevalência solução defeito'))+" ")])]),_c('v-expansion-panel-content',[_c('DefectSolutionPrev',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.6 - Prevalência solução defeito'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '1.6 - Prevalência solução defeito'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.6 - Prevalência solução defeito'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '1.6 - Prevalência solução defeito'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.7 - Serviços solicitados x concluídos - Período'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.7")]),_vm._v(" "+_vm._s(_vm.$t('Serviços solicitados x concluídos - Período'))+" ")])]),_c('v-expansion-panel-content',[_c('SolicitedVConcluded',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.7 - Serviços solicitados x concluídos - Período'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.7 - Serviços solicitados x concluídos - Período'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.7 - Serviços solicitados x concluídos - Período'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.7 - Serviços solicitados x concluídos - Período'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.8 - Corretivas solicitadas x executadas - Acumulado'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.8")]),_vm._v(" "+_vm._s(_vm.$t('Corretivas solicitadas x executadas - Acumulado'))+" ")])]),_c('v-expansion-panel-content',[_c('CorrectiveScheXExec',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.8 - Corretivas solicitadas x executadas - Acumulado'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.8 - Corretivas solicitadas x executadas - Acumulado'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.8 - Corretivas solicitadas x executadas - Acumulado'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.8 - Corretivas solicitadas x executadas - Acumulado'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('1.9 - Resolutividade interna'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.9")]),_vm._v(" "+_vm._s(_vm.$t('Resolutividade Interna'))+" ")])]),_c('v-expansion-panel-content',[_c('InternalResolvability',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.9 - Resolutividade interna'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.9 - Resolutividade interna'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.9 - Resolutividade interna'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.9 - Resolutividade interna'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('1.10 - Preventiva x Corretiva'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.10")]),_vm._v(" "+_vm._s(_vm.$t('Preventiva x Corretiva'))+" ")])]),_c('v-expansion-panel-content',[_c('PreventiveXCorrective',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.10 - Preventiva x Corretiva'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.10 - Preventiva x Corretiva'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.10 - Preventiva x Corretiva'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.10 - Preventiva x Corretiva'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.11 - Preventivas agendadas x executadas - Acumulado'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.11")]),_vm._v(" "+_vm._s(_vm.$t('Preventivas Agendadas x Executadas - Acumulado'))+" ")])]),_c('v-expansion-panel-content',[_c('PreventiveSchedXExec',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.11 - Preventivas agendadas x executadas - Acumulado'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.11 - Preventivas agendadas x executadas - Acumulado'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.11 - Preventivas agendadas x executadas - Acumulado'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.11 - Preventivas agendadas x executadas - Acumulado'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.12 - Calibrações agendadas x executadas'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.12")]),_vm._v(" "+_vm._s(_vm.$t('Calibrações agendadas x executadas - Acumulado'))+" ")])]),_c('v-expansion-panel-content',[_c('CalibSchedXExec',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart == '1.12 - Calibrações agendadas x executadas'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.12 - Calibrações agendadas x executadas'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart == '1.12 - Calibrações agendadas x executadas'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.12 - Calibrações agendadas x executadas'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.13 - Segurança elétrica agendada x executada - acumulado'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.13")]),_vm._v(" "+_vm._s(_vm.$t('Segurança Elétrica agendada x executada - Acumulado'))+" ")])]),_c('v-expansion-panel-content',[_c('EletricSecSchedXExec',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.13 - Segurança elétrica agendada x executada - acumulado'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.13 - Segurança elétrica agendada x executada - acumulado'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.13 - Segurança elétrica agendada x executada - acumulado'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.13 - Segurança elétrica agendada x executada - acumulado'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.14 - Histórico de migração de equipamentos'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.14")]),_vm._v(" "+_vm._s(_vm.$t('Histórico de migração de equipamentos'))+" ")])]),_c('v-expansion-panel-content',[_c('HistoricalMigration',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.14 - Histórico de migração de equipamentos'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.14 - Histórico de migração de equipamentos'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.14 - Histórico de migração de equipamentos'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.14 - Histórico de migração de equipamentos'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '1.15 - Ordens de serviço por responsável - Período'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.15")]),_vm._v(" Ordens de serviço por responsável - Período ")])]),_c('v-expansion-panel-content',[_c('ResponsibleServicesByWeek',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.15 - Ordens de serviço por responsável - Período'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.15 - Ordens de serviço por responsável - Período'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '1.15 - Ordens de serviço por responsável - Período'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '1.15 - Ordens de serviço por responsável - Período'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.institution.departmentTypes.includes(1) &&
                _vm.selection.includes('1.16 - Solicitações por Oficina')
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("1.16")]),_vm._v(" "+_vm._s(_vm.$t('Solicitações por Oficina'))+" ")])]),_c('v-expansion-panel-content',[_c('OrderByWorkshop',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.16 - Solicitações por Oficina'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.16 - Solicitações por Oficina'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '1.16 - Solicitações por Oficina'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '1.16 - Solicitações por Oficina'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e()],1)],1)],1)],1)],1):_vm._e(),(_vm.selection.filter((x) => x.includes('1.')).length > 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-divider')],1):_vm._e(),(_vm.selection.filter((x) => x.includes('2.')).length > 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('strong',[_vm._v(_vm._s(_vm.$t('Tempos')))])]),_c('v-expansion-panel-content',[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[(_vm.selection.includes('2.1 - Tempo de máquina parada'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.1")]),_vm._v(" "+_vm._s(_vm.$t('Tempo de máquina parada'))+" ")])]),_c('v-expansion-panel-content',[_c('StoppedMachine',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.1 - Tempo de máquina parada'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '2.1 - Tempo de máquina parada'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.1 - Tempo de máquina parada'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '2.1 - Tempo de máquina parada'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '2.2 - Tempo médio entre falhas por equipamento padrão'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.2")]),_vm._v(" "+_vm._s(_vm.$t('Tempo médio entre falhas por equipamento padrão'))+" ")])]),_c('v-expansion-panel-content',[_c('StandEquipFailures',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.2 - Tempo médio entre falhas por equipamento padrão'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.2 - Tempo médio entre falhas por equipamento padrão'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.2 - Tempo médio entre falhas por equipamento padrão'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.2 - Tempo médio entre falhas por equipamento padrão'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '2.3 - Tempo médio entre falhas por equipamento'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.3")]),_vm._v(" "+_vm._s(_vm.$t('Tempo médio entre falhas por equipamento'))+" ")])]),_c('v-expansion-panel-content',[_c('TotalServiceTime',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.3 - Tempo médio entre falhas por equipamento'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.3 - Tempo médio entre falhas por equipamento'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.3 - Tempo médio entre falhas por equipamento'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.3 - Tempo médio entre falhas por equipamento'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes('2.4 - Atendimento x Previsão atendimento')
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.4")]),_vm._v(" "+_vm._s(_vm.$t('Atendimento x Previsão atendimento'))+" ")])]),_c('v-expansion-panel-content',[_c('ServiceForecast',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart == '2.4 - Atendimento x Previsão atendimento'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.4 - Atendimento x Previsão atendimento'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart == '2.4 - Atendimento x Previsão atendimento'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.4 - Atendimento x Previsão atendimento'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('2.5 - Chamados atendidos no prazo'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.5")]),_vm._v(" "+_vm._s(_vm.$t('Chamados Corretivos Atendidos no Prazo'))+" ")])]),_c('v-expansion-panel-content',[_c('CallsAnsweredChart',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.5 - Chamados atendidos no prazo'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '2.5 - Chamados atendidos no prazo'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.5 - Chamados atendidos no prazo'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '2.5 - Chamados atendidos no prazo'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes('2.6 - Resolução x Previsão resolução')
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.6")]),_vm._v(" "+_vm._s(_vm.$t('Resolução x Previsão resolução'))+" ")])]),_c('v-expansion-panel-content',[_c('ResolutionForecast',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.6 - Resolução x Previsão resolução'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '2.6 - Resolução x Previsão resolução'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.6 - Resolução x Previsão resolução'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '2.6 - Resolução x Previsão resolução'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('2.7 - Chamados resolvidos no prazo'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.7")]),_vm._v(" "+_vm._s(_vm.$t('Chamados Corretivos Resolvidos no Prazo'))+" ")])]),_c('v-expansion-panel-content',[_c('CallsResolvedChart',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '2.7 - Chamados resolvidos no prazo'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '2.7 - Chamados resolvidos no prazo'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '2.8 - Tempo de atendimento interno por setor'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.8")]),_vm._v(" "+_vm._s(_vm.$t('Tempo de Atendimento Interno por Setor'))+" ")])]),_c('v-expansion-panel-content',[_c('ServiceTimeDepartment',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.8 - Tempo de atendimento interno por setor'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.8 - Tempo de atendimento interno por setor'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.8 - Tempo de atendimento interno por setor'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.8 - Tempo de atendimento interno por setor'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '2.9 - Tempo de atendimento interno por criticidade'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.9")]),_vm._v(" "+_vm._s(_vm.$t('Tempo de atendimento interno por criticidade'))+" ")])]),_c('v-expansion-panel-content',[_c('ServiceTimeCrit',{attrs:{"filterProp":_vm.isEditing
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.9 - Tempo de atendimento interno por criticidade'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.9 - Tempo de atendimento interno por criticidade'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.9 - Tempo de atendimento interno por criticidade'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('2.10 - Tempo produtivo'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.10")]),_vm._v(" "+_vm._s(_vm.$t('Tempo Produtivo'))+" ")])]),_c('v-expansion-panel-content',[_c('ProdTime',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.10 - Tempo produtivo'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '2.10 - Tempo produtivo'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.10 - Tempo produtivo'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '2.10 - Tempo produtivo'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('2.11 - Tempo produtivo por setor'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.11")]),_vm._v(" "+_vm._s(_vm.$t('Tempo produtivo por setor'))+" ")])]),_c('v-expansion-panel-content',[_c('ProdTimeSector',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.11 - Tempo produtivo por setor'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '2.11 - Tempo produtivo por setor'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '2.11 - Tempo produtivo por setor'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '2.11 - Tempo produtivo por setor'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(
                _vm.selection.includes(
                  '2.12 - Tempo médio de resolução interna por criticidade'
                )
              )?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("2.12")]),_vm._v(" "+_vm._s(_vm.$t('Tempo médio de resolução interna por criticidade'))+" ")])]),_c('v-expansion-panel-content',[_c('ResolutionTimeCrit',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.12 - Tempo médio de resolução interna por criticidade'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.12 - Tempo médio de resolução interna por criticidade'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) =>
                        x.chart ==
                        '2.12 - Tempo médio de resolução interna por criticidade'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart ==
                            '2.12 - Tempo médio de resolução interna por criticidade'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades,"standardEquipments":_vm.standardEquipments},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e()],1)],1)],1)],1)],1):_vm._e(),(_vm.selection.filter((x) => x.includes('2.')).length > 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-divider')],1):_vm._e(),(_vm.selection.filter((x) => x.includes('3.')).length > 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('strong',[_vm._v(_vm._s(_vm.$t('Custos de Manutenção')))])]),_c('v-expansion-panel-content',[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[(_vm.selection.includes('3.1 - Custos por peça avulsa'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("3.1")]),_vm._v(" "+_vm._s(_vm.$t('Custos por Peça Avulsa'))+" ")])]),_c('v-expansion-panel-content',[_c('CostPerPiece',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '3.1 - Custos por peça avulsa'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.1 - Custos por peça avulsa'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '3.1 - Custos por peça avulsa'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.1 - Custos por peça avulsa'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('3.2 - Custos por serviço avulso'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("3.2")]),_vm._v(" "+_vm._s(_vm.$t('Custos por serviço avulso'))+" ")])]),_c('v-expansion-panel-content',[_c('CostPerService',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '3.2 - Custos por serviço avulso'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.2 - Custos por serviço avulso'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '3.2 - Custos por serviço avulso'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.2 - Custos por serviço avulso'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('3.3 - Custo por setor'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("3.3")]),_vm._v(" Custos por setor ")])]),_c('v-expansion-panel-content',[_c('CostPerSector',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find((x) => x.chart == '3.3 - Custo por setor')
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.3 - Custo por setor'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find((x) => x.chart == '3.3 - Custo por setor')
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.3 - Custo por setor'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('3.4 - Custo por ID equipamento'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("3.4")]),_vm._v(" "+_vm._s(_vm.$t('Custos por ID de equipamento'))+" ")])]),_c('v-expansion-panel-content',[_c('CostPerId',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '3.4 - Custo por ID equipamento'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.4 - Custo por ID equipamento'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '3.4 - Custo por ID equipamento'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.4 - Custo por ID equipamento'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('3.5 - Custo evitado'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("3.5")]),_vm._v(" "+_vm._s(_vm.$t('Custo evitado'))+" ")])]),_c('v-expansion-panel-content',[_c('AvoidedCosts',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find((x) => x.chart == '3.5 - Custo evitado')
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.5 - Custo evitado'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find((x) => x.chart == '3.5 - Custo evitado')
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '3.5 - Custo evitado'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e()],1)],1)],1)],1)],1):_vm._e(),(_vm.selection.filter((x) => x.includes('3.')).length > 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-divider')],1):_vm._e(),(_vm.selection.filter((x) => x.includes('4.')).length > 0)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('strong',[_vm._v(_vm._s(_vm.$t('Controle de Qualidade')))])]),_c('v-expansion-panel-content',[_c('v-expansion-panels',{staticStyle:{"border-radius":"8px"},attrs:{"flat":"","hover":""}},[(_vm.selection.includes('4.1 - Notas das avaliações O.S.'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("4.1")]),_vm._v(" "+_vm._s(_vm.$t('Notas das avaliações de Chamados'))+" ")])]),_c('v-expansion-panel-content',[_c('OrderRatings',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '4.1 - Notas das avaliações O.S.'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('4.2 - Ranking fornecedor'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("4.2")]),_vm._v(" "+_vm._s(_vm.$t('Ranking fornecedor'))+" ")])]),_c('v-expansion-panel-content',[_c('RankingSupplier',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '4.2 - Ranking fornecedor'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '4.2 - Ranking fornecedor'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '4.2 - Ranking fornecedor'
                    )
                      ? _vm.chartInfos.find(
                          (x) => x.chart == '4.2 - Ranking fornecedor'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e(),(_vm.selection.includes('4.3 - Adesão ao módulo de chamados'))?_c('v-expansion-panel',{staticClass:"my-2"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex align-center"},[_c('h3',{staticClass:"mr-2"},[_vm._v("4.3")]),_vm._v(" "+_vm._s(_vm.$t('Adesão ao módulo de chamados'))+" ")])]),_c('v-expansion-panel-content',[_c('AdhesionCalledMod',{attrs:{"filterProp":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '4.3 - Adesão ao módulo de chamados'
                        )
                      : {},"review":_vm.isEditing &&
                    _vm.chartInfos.find(
                      (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
                    )
                      ? _vm.chartInfos.find(
                          (x) =>
                            x.chart == '4.3 - Adesão ao módulo de chamados'
                        ).review
                      : '',"institution":_vm.institution,"unidades":_vm.unidades},on:{"setInfos":_vm.saveChartInfo}})],1)],1):_vm._e()],1)],1)],1)],1)],1):_vm._e(),_c('v-col',{attrs:{"cols":"12"}},[_c('v-card-actions',{staticClass:"justify-space-between"},[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('back')}}},[_c('v-icon',[_vm._v("mdi-chevron-left")]),_vm._v(" "+_vm._s(_vm.$t('Voltar'))+" ")],1),_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t('Continuar'))+" "),_c('v-icon',[_vm._v("mdi-chevron-right")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }